import { AxiosResponse } from 'axios'
import { axiosApi, defaultItemPerPage } from './base.api'
import { MaterialModelsPagination, MaterialModel } from '../models/materialModels.models'
import { PaginationParams } from '../models/commons.models'

import { LangEnum } from '../constants/langs'

export namespace MaterialModelsApi {
  export interface GetListParams extends PaginationParams {
    search?: string
    lang?: LangEnum
  }
  export const getList = async (params?: GetListParams): Promise<MaterialModelsPagination> => {
    const response: AxiosResponse<MaterialModelsPagination> = await axiosApi.get(
      `/material-models`,
      {
        params: {
          disablePaginate: false,
          itemsPerPage: defaultItemPerPage,
          page: 0,
          ...params,
        },
      },
    )
    return response.data
  }
  export const create = async (createdMaterialModel: MaterialModel): Promise<MaterialModel> => {
    const response: AxiosResponse<MaterialModel> = await axiosApi.post(
      `/material-models`,
      createdMaterialModel,
    )
    return response.data
  }
  export const getById = async (materialModelId: string): Promise<MaterialModel> => {
    const response: AxiosResponse<MaterialModel> = await axiosApi.get(
      `/material-models/${materialModelId}`,
    )
    return response.data
  }
  export const update = async (
    materialModelId: string,
    updatedMaterialModel: Partial<MaterialModel>,
  ): Promise<MaterialModel> => {
    const response: AxiosResponse<MaterialModel> = await axiosApi.patch(
      `/material-models/${materialModelId}`,
      updatedMaterialModel,
    )
    return response.data
  }
  export const deleteById = async (materialModelId: string): Promise<void> => {
    await axiosApi.delete(`/material-models/${materialModelId}`)
  }
}
